module.exports = __webpack_public_path__ + "media/images/190630-CMN-Nestle-5275c-2-7ac13bd0.jpg";